import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { QuizPage } from './pages/QuizPage';
import { ResultsPage } from './pages/ResultsPage';
import { AdminPage } from './pages/AdminPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/quiz" element={<QuizPage data-id="element-5" />} data-id="element-4" />
        <Route path="/results" element={<ResultsPage data-id="element-7" />} data-id="element-6" />
        <Route path="/admin" element={<AdminPage data-id="element-9" />} data-id="element-8" />
      </Routes>
    </BrowserRouter>;
}